import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useAuth } from '../../hooks/useAuth';

import { ReactComponent as BacklogIcon } from '../../icons/backlog.svg';
import { ReactComponent as ClientsIcon } from '../../icons/clients.svg';
import { ReactComponent as CloseNavIcon } from '../../icons/close-nav.svg';
import { ReactComponent as EmployeesIcon } from '../../icons/employees.svg';
import { ReactComponent as Logo } from '../../icons/logo.svg';
import { ReactComponent as LogoutIcon } from '../../icons/logout.svg';
import { ReactComponent as OpenNavIcon } from '../../icons/open-nav.svg';
import { ReactComponent as ReportsIcon } from '../../icons/reports.svg';
import { ReactComponent as ServicesIcon } from '../../icons/services.svg';
import { ReactComponent as SettingsIcon } from '../../icons/settings.svg';
import { ReactComponent as TasksIcon } from '../../icons/tasks.svg';

import './navigation.scss';

import { useAppUser } from '../../api/hooks/useAppUser';
import { LoadingText } from '../loader/text/LoadingText';
import { ProfileImage } from '../profile-image/ProfileImage';

const navigationItems = [
  {
    id: 1,
    title: 'Tasks',
    icon: <TasksIcon />,
    path: '/'
  },
  {
    id: 2,
    title: 'Backlog',
    icon: <BacklogIcon />,
    path: '/backlog'
  },
  {
    id: 3,
    title: 'Clients',
    icon: <ClientsIcon />,
    path: '/clients'
  },
  {
    id: 4,
    title: 'Services',
    icon: <ServicesIcon />,
    path: '/services'
  },
  {
    id: 5,
    title: 'Employees',
    icon: <EmployeesIcon />,
    path: '/employees'
  },
  {
    id: 6,
    title: 'Reports',
    icon: <ReportsIcon />,
    path: '/reports'
  },
  {
    id: 7,
    title: 'Settings',
    icon: <SettingsIcon />,
    path: '/settings',
    footer: true
  },
  {
    id: 8,
    title: 'Logout',
    icon: <LogoutIcon />,
    footer: true,
    logoutAction: true
  }
];

export const Navigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [minimized, setMinimized] = React.useState(false);
  const { signOut } = useAuth();
  const { appUser, loading: appUserLoading } = useAppUser();
  const { user } = useAuth();

  return (
    <div className={`navigation ${minimized ? 'navigation--minimized' : ''}`}>
      <div className="navigation__header">
        <div onClick={() => setMinimized(!minimized)}>
          {!minimized && (
            <div>
              <Logo />
              <span>FinTask</span>
            </div>
          )}
          {minimized ? <OpenNavIcon /> : <CloseNavIcon />}
        </div>
      </div>
      <div className="navigation__items-wrapper">
        <div className="navigation__items">
          {navigationItems
            .filter((item) => !item.footer)
            .map((item, index) => (
              <div
                onClick={() => navigate(item.path)}
                key={index}
                className={`navigation__item ${location.pathname === item.path ? 'navigation__item--selected' : ''}`}
              >
                {item.icon}
                {!minimized && <span>{item.title}</span>}
              </div>
            ))}
        </div>
        <div className="navigation__items">
          {navigationItems
            .filter((item) => item.footer)
            .map((item, index) => (
              <div
                onClick={item?.logoutAction ? () => signOut() : () => navigate(item.path)}
                key={index}
                className={`navigation__item ${location.pathname === item.path ? 'navigation__item--selected' : ''}`}
              >
                {item.icon}
                {!minimized && <span>{item.title}</span>}
              </div>
            ))}
        </div>
      </div>
      <div className="navigation__user">
        <div>
          <ProfileImage
            width={40}
            height={40}
            profile={{
              name: appUser && !appUserLoading ? `${appUser?.firstName} ${appUser?.lastName}` : null
            }}
            loading={appUserLoading}
          />
          {!minimized && (
            <div>
              <LoadingText loading={appUserLoading} height={19} width={150}>
                {appUser && !appUserLoading
                  ? `${appUser?.firstName} ${appUser?.lastName}`
                  : 'Unknown'}
              </LoadingText>
              <LoadingText loading={appUserLoading} height={14} width={200}>
                {user?.email ?? 'Unknown'}
              </LoadingText>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
